export enum AppointmentInfoType {
    WAITINGROOM = 'waitingroom',
    UPCOMING = 'upcoming',
    HISTORY = 'history',
    CANCELED = 'canceled'
}
